export default function () {
  $(window).load(function () {
    const textForHeaderSignUp = 'Enter Your Email and Get Free Admission!';
    const textForCountdown = 'Sending you to the next page in ';
    const pageToBeRedirected = 'https://www.alabamastatefair.com/p/extra/free-admission-days';

    let submitEmail = $('#signup-container .emailSignup .inputFieldSubmit');
    let inputEmail = $('#signup-container .emailSignup input');
    $('#signup-container .emailSignup .emailSignupText').remove();
    $('#signup-container .emailSignup .emailInputField').prepend(`
    <div id="coupon-box">
      <h2>${textForHeaderSignUp}</h2>
    </div>
  `);
    $('#signup-container .emailSignup .emailInputSubmit .inputFieldSubmit ').text('Submit');

    // Input email enter event
    $(inputEmail).keydown(function (event) {
      if (event.key == 'Enter') {
        submitForm();
      }
    });

    // Click event
    $(submitEmail).on('keypress click', function (event) {
      if (event.key == 'Enter' || event.type == 'click') {
        submitForm();
      }
    });

    // Launch ticket function
    function submitForm() {
      let validationInProgress = true;
      setTimeout(function () {
        validationInProgress = false;
      }, 2000);

      let validationInterval = setInterval(function () {
        if (!validationInProgress) {
          clearInterval(validationInterval);
          return;
        }

        if ($('body').hasClass('hideBackToTop')) {
          clearInterval(validationInterval);
          $('body').append(
            `<div class="coupon-opening">${textForCountdown} <span id="seconds">5</span> seconds...</div>`,
          );
          countdown(4);
          setTimeout(() => {
            parent.location.href = pageToBeRedirected;
          }, 3000);
        }
      }, 100);
    }

    // Countdown for opening PDF
    function countdown(seconds) {
      const countdownDiv = document.getElementById('seconds');
      let timer = setInterval(() => {
        countdownDiv.textContent = seconds;
        seconds--;

        if (seconds < 0) {
          clearInterval(timer);
        }
      }, 1000);
    }
  });

  $(window).load(function () {
    const movedSignUp = $('#signup-tickets');
    const signUpContainer = $('#signup-container');

    if ($(movedSignUp).length) {
      movedSignUp.append(signUpContainer);
    } else {
      $(signUpContainer).remove();
    }
  });
}
